import DesktopHeader from "../components/defaultHeader/DesktopHeader";
import Heading from "../components/typography/Heading";
import { Flex } from "@chakra-ui/react";
import ProfileCategoriesCard from "../features/profile/ProfileCategoriesCard";
import MedicalLicenseCard from "../features/profile/MedicalLicens";

const MedicalLicensePage = () => {
  return (
    <>
      <DesktopHeader headerContent={<Heading>My Profile</Heading>} />
      <Flex px={"48px"}>
        <ProfileCategoriesCard active={"Medical license"} />
        <MedicalLicenseCard />
      </Flex>
    </>
  );
};

export default MedicalLicensePage;
